import { Controller }  from "stimulus"
import { roundNumber } from "@react/quotes/form/helpers"

export default class extends Controller {
  static targets = [ "container", "percentageInput", "amountInput", "sliderInput" ]

  connect() {
    this.hide()
    this.syncFromPercentage(this.data.get("percentage"))
  }

  hide() {
    this.containerTarget.classList.add("d-none")
    this.percentageInputTarget.disabled = true
  }

  show() {
    this.percentageInputTarget.disabled = false
    this.containerTarget.classList.remove("d-none")
    this.syncFromPercentage(this.data.get("percentage"))
  }

  showDeposit() {
    this.data.set("percentage", this.data.get("depositPercentage"))
    this.show()
  }

  changePercentage() {
    const max = this.maxPercentage()
    let percentage = parseFloat(this.percentageInputTarget.value)
    if (isNaN(percentage)) percentage = 0
    if (percentage > max) {
      percentage = max
      this.percentageInputTarget.value = percentage
    }
    if (percentage < 0) {
      percentage = 0
      this.percentageInputTarget.value = 0
    }
    this.data.set("percentage", percentage)
    this.amountInputTarget.value = this.amountFromPercentage(percentage)
    if (this.hasSliderInputTarget) this.sliderInputTarget.value = percentage
  }

  changeSlider() {
    const max = this.maxPercentage()
    let percentage = parseFloat(this.sliderInputTarget.value)
    if (isNaN(percentage)) percentage = 0
    if (percentage > max) percentage = max
    if (percentage < 0) percentage = 0
    this.data.set("percentage", percentage)
    this.percentageInputTarget.value = percentage
    this.amountInputTarget.value = this.amountFromPercentage(percentage)
  }

  changeAmount() {
    const total = roundNumber(this.data.get("total"))
    const max   = this.maxAmount()
    let amount  = parseFloat(this.amountInputTarget.value)
    if (isNaN(amount)) amount = 0
    if (amount > max) {
      amount = max
      this.amountInputTarget.value = amount
    }
    if (amount < 0) {
      amount = 0
      this.amountInputTarget.value = 0
    }
    const percentage = total > 0 ? (amount / total) * 100 : 0
    const rounded    = Math.round(percentage * 100) / 100
    this.data.set("percentage", rounded)
    this.percentageInputTarget.value = rounded
    if (this.hasSliderInputTarget) this.sliderInputTarget.value = rounded
  }

  syncFromPercentage(value) {
    const percentage = roundNumber(value)
    this.percentageInputTarget.value = percentage
    this.amountInputTarget.value     = this.amountFromPercentage(percentage)
    if (this.hasSliderInputTarget) this.sliderInputTarget.value = percentage
  }

  amountFromPercentage(percentage) {
    const total = roundNumber(this.data.get("total"))
    return roundNumber(total * percentage / 100)
  }

  maxPercentage() {
    return parseFloat(this.percentageInputTarget.getAttribute('max')) || 100
  }

  maxAmount() {
    const total = roundNumber(this.data.get("total"))
    return roundNumber(total * this.maxPercentage() / 100)
  }
}
